import Property from "../model/property";
import i18n from "../i18n";
import { appConfig } from "../config/app-config";

export const isSixSensesBrand = () => {
  const propertyData = Property.getData();
  const brandName = propertyData?.brand?.name || appConfig?.brand || "";
  return brandName.toLowerCase().includes("six senses");
};

export const isVietnameseChar = (text) => {
  if (typeof text !== "string") return false;
  const viRe = /[Ạ-ỹơƠưƯđĐăĂ]/;
  return viRe.test(text);
};

export const shouldUseViStoreFont = (node, currentLanguage) => {
  const lang =
    currentLanguage ||
    i18n?.language ||
    Property.getDefaultLanguage() ||
    "";
  if (lang === "vi" || (typeof lang === "string" && lang.startsWith("vi"))) {
    return true;
  }

  const viRe = /[Ạ-ỹơƠưƯđĐăĂ]/;
  const testString = (str) => typeof str === "string" && viRe.test(str);

  const testNode = (n) =>
    testString(n?.title) ||
    testString(n?.subtitle) ||
    testString(n?.item_name) ||
    testString(n?.name) ||
    testString(n?.description);

  if (!node) return false;

  if (Array.isArray(node)) {
    return node.some((item) => shouldUseViStoreFont(item, lang));
  }

  const children =
    node.children || node.categories || node.sections || node.products || [];
  if (children.length > 0) {
    return (
      children.some((child) => shouldUseViStoreFont(child, lang)) ||
      testNode(node)
    );
  }

  return testNode(node);
};

export const updateViFontStatus = (currentLang) => {
  const propertyData = Property.getData();
  const lang =
    currentLang ||
    i18n?.language ||
    Property.getDefaultLanguage() ||
    "en";
  const useViFont = shouldUseViStoreFont(propertyData, lang);

  if (typeof document !== "undefined") {
    if (useViFont) {
      document.body.classList.add("use-vi-font");
      document.documentElement.classList.add("use-vi-font");
    } else {
      document.body.classList.remove("use-vi-font");
      document.documentElement.classList.remove("use-vi-font");
    }
  }

  return useViFont;
};
